import { c as _c } from "react/compiler-runtime";
import { Button } from '@petsmart-ui/sparky';
import type { MenuQuickLink, PrimaryNavigationItem } from '../../../types';
import { Drawer } from './drawer';
import { useMobileMenu } from './use-mobile-menu';
import './mobile-menu.scss';
type MobileMenuProps = {
  items: PrimaryNavigationItem[];
  quickLinks: MenuQuickLink[];
};
export function MobileMenu(t0) {
  const $ = _c(14);
  const {
    items,
    quickLinks
  } = t0;
  const {
    closeMenu,
    handleOpenChangeComplete,
    isOpen,
    openMenu,
    setIsOpen,
    triggerRef
  } = useMobileMenu();
  let t1;
  if ($[0] !== isOpen || $[1] !== openMenu || $[2] !== triggerRef) {
    t1 = <Button buttonRef={triggerRef} aria-expanded={isOpen} aria-label="Open menu" iconSize="lg" iconName="menu" variant="bare" className="mobile-menu" onClick={openMenu} />;
    $[0] = isOpen;
    $[1] = openMenu;
    $[2] = triggerRef;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== closeMenu || $[5] !== handleOpenChangeComplete || $[6] !== isOpen || $[7] !== items || $[8] !== quickLinks || $[9] !== setIsOpen) {
    t2 = <Drawer isOpen={isOpen} items={items} onCloseAll={closeMenu} onOpenChange={setIsOpen} onOpenChangeComplete={handleOpenChangeComplete} quickLinks={quickLinks} />;
    $[4] = closeMenu;
    $[5] = handleOpenChangeComplete;
    $[6] = isOpen;
    $[7] = items;
    $[8] = quickLinks;
    $[9] = setIsOpen;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  let t3;
  if ($[11] !== t1 || $[12] !== t2) {
    t3 = <>{t1}{t2}</>;
    $[11] = t1;
    $[12] = t2;
    $[13] = t3;
  } else {
    t3 = $[13];
  }
  return t3;
}